/* Exowide Atelier – site-wide behaviour (menu, reveal motion, cart count, recommendations) */
(function () {
  'use strict';
  var html = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Mobile menu */
  function initMenu() {
    var button = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!button || !nav) return;
    function setOpen(open) {
      button.setAttribute('aria-expanded', String(open));
      nav.hidden = !open;
      html.classList.toggle('menu-open', open);
    }
    button.addEventListener('click', function () {
      setOpen(button.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        button.focus();
      }
    });
  }

  /* Scroll reveal – only when enabled in theme settings and motion is allowed */
  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    if (html.getAttribute('data-animations') !== 'true' || reduceMotion || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-visible'); });
      return;
    }
    html.classList.add('js-motion');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    Array.prototype.forEach.call(items, function (el) { io.observe(el); });
  }

  /* Header cart count */
  function refreshCartCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
          el.textContent = String(cart.item_count);
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* Product recommendations (Shopify Section Rendering API) */
  function initRecommendations() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-recommendations]'), function (section) {
      var url = section.getAttribute('data-url');
      if (!url || section.children.length) return;
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (text) {
          if (!text) return;
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            section.innerHTML = fresh.innerHTML;
            initCardSwatches(section);
            Array.prototype.forEach.call(section.querySelectorAll('.reveal'), function (el) { el.classList.add('is-visible'); });
          }
        })
        .catch(function () {});
    });
  }

  /* Product card colour swatches: preview the colour, link to that variant */
  function initCardSwatches(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-product-card]'), function (card) {
      if (card.__swatches) return;
      card.__swatches = true;
      var img = card.querySelector('.product-image:not(.product-image--hover)');
      var swatches = card.querySelectorAll('[data-card-swatch]');
      if (!swatches.length) return;
      function select(btn) {
        Array.prototype.forEach.call(swatches, function (b) { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        if (img && btn.getAttribute('data-src')) {
          img.srcset = btn.getAttribute('data-srcset') || '';
          img.src = btn.getAttribute('data-src');
          card.classList.add('has-swatch-preview');
        }
        var url = btn.getAttribute('data-url');
        if (url) Array.prototype.forEach.call(card.querySelectorAll('[data-card-link]'), function (a) { a.href = url; });
      }
      Array.prototype.forEach.call(swatches, function (btn) {
        btn.setAttribute('aria-pressed', 'false');
        btn.addEventListener('click', function () { select(btn); });
        btn.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) select(btn); });
        btn.addEventListener('focus', function () { select(btn); });
      });
    });
  }

  /* Sticky header that hides while scrolling down */
  function initStickyHeader() {
    if (html.getAttribute('data-sticky-header') !== 'true') return;
    var last = window.scrollY, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY;
        var menuOpen = html.classList.contains('menu-open');
        html.classList.toggle('header-scrolled', y > 10);
        if (!menuOpen && Math.abs(y - last) > 6) html.classList.toggle('header-hidden', y > last && y > 160);
        last = y; ticking = false;
      });
    }, { passive: true });
  }

  function init() {
    initCardSwatches();
    initStickyHeader();
    initMenu();
    initReveal();
    initRecommendations();
  }

  document.addEventListener('exowide:cart-updated', refreshCartCount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
